export default [
    {
		path: "/forms",
		component: () => import("../views/Forms/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/forms/list/:list?",
		component: () => import("../views/Forms/List.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/forms/:formid/responses/:formresponseid/stage/:stageid",
		component: () => import("../views/Forms/Edit.vue"),
	},
	{
		path: "/forms/view/:formresponseid?",
		component: () => import("../views/Forms/Edit.vue"),
	},
	{
		path: "/forms/workbook/:workbookid?",
		component: () => import("../views/Forms/Workbook.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/forms/assign",
		component: () => import("../views/Forms/Assign.vue"),
	},
]
